import { render, staticRenderFns } from "./TabPriceList.vue?vue&type=template&id=3356ab4f&"
import script from "./TabPriceList.vue?vue&type=script&lang=js&"
export * from "./TabPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports